import { Injectable } from '@angular/core';
import { ConfigService } from './config.service';
declare let ga: Function;

@Injectable({
  providedIn: 'root'
})

export class AnalyticsService{

    constructor( private configService: ConfigService ) {}

    public async trackEvent(event) {

        console.log(`My Vote GA Event ${event} fired from iFrame`);
        parent.postMessage(event, "https://ballotpedia.org");

    }

}

/* 

The code above is using postMessage to talk to the Parent page the iFrame is embedded on.

We call Google Analytics from the Parent Page instead of within the app because of cross domain issues, 
so the following needs to be embedded on the Parent Page:

<script>
function handleAnalytics(event) {
    var eventTypes = ['submit address', 'view results', 'print', 'visit candidate profile', 'visit ballot measure'];

    if (eventTypes.includes(event.data)) {
      console.log("Handle analytics called on Parent Page");
      console.log("Event:");
      console.log(event.data);
      ga('send', 'event', 'Sample Ballot Lookup', event.data);
    }

}
 window.addEventListener("message", handleAnalytics, false);
</script>

*/